export const SETTLEMENT_TRADING = [
  { id: 'SETTLEMENT', displayValue: 'Settlement' },
  { id: 'TRADING', displayValue: 'Trading' },
];
